module.exports = __webpack_public_path__ + "static/img/detail.3f59696.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/navigation/image/detail.png
// module id = UMkg
// module chunks = 0